export default {
  "zh-CN": {
    decoration: {
      channel: "个性装扮",
      shopTitle: "个性装扮",
      shopSubtitle: "挑选属于你的头像框和飘屏特效，购买后永久使用。",
      myTitle: "我的装扮库",
      mySubtitle: "头像框、飘屏与等级权益互不冲突，可随时更换。",
      avatarFrames: "头像框",
      floatingScreens: "飘屏特效",
      categoryLabel: "装扮分类",
      sortLabel: "排序",
      sortRecommended: "推荐",
      priceLow: "价格从低到高",
      priceHigh: "价格从高到低",
      preview: "预览",
      previewItem: "预览“{name}”",
      previewTitle: "装扮预览",
      previewHint: "这是装扮应用后的预览效果。",
      closePreview: "关闭预览",
      avatarPreviewAlt: "我的头像",
      loadMore: "加载更多",
      loadingMore: "正在加载",
      allLoaded: "已展示全部 {count} 件装扮",
      loadFailed: "装扮加载失败，请稍后重试",
      retry: "重新加载",
      emptyFrameTitle: "还没有头像框",
      emptyFrameHint: "让你的头像多一点星光，挑一个喜欢的头像框吧。",
      browseFrames: "去挑选头像框",
      owned: "已拥有",
      inUse: "使用中",
      empty: "这里还没有可用装扮",
      equip: "立即佩戴",
      remove: "取消佩戴",
      purchaseTitle: "确认购买",
      purchaseConfirm: "购买“{name}”将消费 {price} 金币，购买后永久拥有。",
      buyNow: "确认购买",
      purchaseSuccess: "“{name}”已加入我的装扮库",
      equipSuccess: "装扮已佩戴",
      removeSuccess: "已取消佩戴",
      liveEntered: "{name} 闪耀入场",
      defaultEntrance: "StarLive 星光入场",
      levelEntrance: "StarLive Lv.{level} 等级飘屏"
    },
    decorationErrors: {
      invalidType: "装扮类型不正确",
      invalidSort: "装扮排序方式不正确",
      notFound: "该装扮已下架或不存在",
      alreadyOwned: "你已经拥有该装扮",
      notOwned: "尚未获得该装扮",
      purchased: "购买成功",
      equipped: "佩戴成功"
    }
  },
  "en-US": {
    decoration: {
      channel: "Style",
      shopTitle: "Style Atelier",
      shopSubtitle: "Choose avatar frames and entrance effects. Every purchase is yours permanently.",
      myTitle: "My Style",
      mySubtitle: "Frames, entrance effects and level benefits stay independent. Switch them anytime.",
      avatarFrames: "Avatar Frames",
      floatingScreens: "Entrance Effects",
      categoryLabel: "Style categories",
      sortLabel: "Sort",
      sortRecommended: "Recommended",
      priceLow: "Price: low to high",
      priceHigh: "Price: high to low",
      preview: "Preview",
      previewItem: "Preview “{name}”",
      previewTitle: "Style preview",
      previewHint: "Preview how this style looks when applied.",
      closePreview: "Close preview",
      avatarPreviewAlt: "My avatar",
      loadMore: "Load more",
      loadingMore: "Loading",
      allLoaded: "All {count} items shown",
      loadFailed: "Unable to load style items. Try again.",
      retry: "Try again",
      emptyFrameTitle: "No avatar frame yet",
      emptyFrameHint: "Add a little starlight to your avatar with a frame that feels like you.",
      browseFrames: "Choose a frame",
      owned: "Owned",
      inUse: "In use",
      empty: "No style items are available yet",
      equip: "Equip",
      remove: "Unequip",
      purchaseTitle: "Confirm purchase",
      purchaseConfirm: "Buy “{name}” for {price} coins? This item will be yours permanently.",
      buyNow: "Buy now",
      purchaseSuccess: "“{name}” was added to My Style",
      equipSuccess: "Style item equipped",
      removeSuccess: "Style item removed",
      liveEntered: "{name} entered in style",
      defaultEntrance: "StarLive Starlight Entrance",
      levelEntrance: "StarLive Lv.{level} Level Entrance"
    },
    decorationErrors: {
      invalidType: "This style item type is invalid.",
      invalidSort: "This style item sort order is invalid.",
      notFound: "This style item is unavailable.",
      alreadyOwned: "You already own this style item.",
      notOwned: "You do not own this style item yet.",
      purchased: "Purchase successful.",
      equipped: "Style item equipped."
    }
  },
  "ar-SA": {
    decoration: {
      channel: "المظهر",
      shopTitle: "استوديو المظهر",
      shopSubtitle: "اختر إطارات الصور وتأثيرات الدخول. تظل مشترياتك متاحة بشكل دائم.",
      myTitle: "مظهري",
      mySubtitle: "يمكن تغيير الإطارات وتأثيرات الدخول ومزايا المستوى بشكل مستقل في أي وقت.",
      avatarFrames: "إطارات الصورة",
      floatingScreens: "تأثيرات الدخول",
      categoryLabel: "فئات المظهر",
      sortLabel: "الترتيب",
      sortRecommended: "موصى به",
      priceLow: "السعر: من الأقل إلى الأعلى",
      priceHigh: "السعر: من الأعلى إلى الأقل",
      preview: "معاينة",
      previewItem: "معاينة «{name}»",
      previewTitle: "معاينة المظهر",
      previewHint: "عاين شكل هذا العنصر بعد تطبيقه.",
      closePreview: "إغلاق المعاينة",
      avatarPreviewAlt: "صورتي الشخصية",
      loadMore: "تحميل المزيد",
      loadingMore: "جارٍ التحميل",
      allLoaded: "تم عرض كل العناصر وعددها {count}",
      loadFailed: "تعذر تحميل عناصر المظهر. حاول مجدداً.",
      retry: "إعادة المحاولة",
      emptyFrameTitle: "لا يوجد إطار للصورة بعد",
      emptyFrameHint: "أضف لمسة من ضوء النجوم إلى صورتك واختر إطاراً يناسبك.",
      browseFrames: "اختيار إطار",
      owned: "مملوك",
      inUse: "قيد الاستخدام",
      empty: "لا توجد عناصر مظهر متاحة بعد",
      equip: "استخدام",
      remove: "إزالة",
      purchaseTitle: "تأكيد الشراء",
      purchaseConfirm: "شراء «{name}» مقابل {price} عملة؟ سيبقى العنصر ملكك دائماً.",
      buyNow: "شراء الآن",
      purchaseSuccess: "تمت إضافة «{name}» إلى مظهري",
      equipSuccess: "تم استخدام عنصر المظهر",
      removeSuccess: "تمت إزالة عنصر المظهر",
      liveEntered: "دخل {name} بتأثير مميز",
      defaultEntrance: "دخول StarLive المتلألئ",
      levelEntrance: "تأثير دخول StarLive للمستوى {level}"
    },
    decorationErrors: {
      invalidType: "نوع عنصر المظهر غير صالح.",
      invalidSort: "ترتيب عناصر المظهر غير صالح.",
      notFound: "عنصر المظهر غير متاح.",
      alreadyOwned: "أنت تملك عنصر المظهر هذا بالفعل.",
      notOwned: "لم تحصل على عنصر المظهر هذا بعد.",
      purchased: "تم الشراء بنجاح.",
      equipped: "تم استخدام عنصر المظهر."
    }
  }
}
